// extracted by mini-css-extract-plugin
export default {"zoomControls":"J--z","zoomControlButton":"K--z","zoomBanner":"L--z","bannerButton":"M--z","imageButton":"N--z","zoom":"O--z","zoomContent":"P--z"};